import { FieldProps, FormType } from '../form-design/type/form';
import { FormInput, FormSelect, FormRadio, FormFile, FormCheckbox, FormTextarea } from '../form-design';
import { FormTitleType, FormTitle } from '../form/TransText';

import './style.scss';

export type GroupProps = {
  title?: FormTitleType;
  des?: string;
  formList: FieldProps[];
  /** 仅仅作为是否显示*号 */
  required?: boolean;
};

function FormGroup(props: GroupProps) {
  const { title, des, formList, required = false } = props;
  function RenderFormItem(item: FieldProps) {
    const { type } = item;
    switch (type) {
      case FormType.INPUT:
        return <FormInput {...item} />;
      case FormType.SELECT:
        return <FormSelect {...item} />;
      case FormType.RADIO:
        return <FormRadio {...item} />;
      case FormType.FILE:
        return <FormFile {...item} />;
      case FormType.CHECKBOX:
        return <FormCheckbox {...item} />;
      case FormType.TEXTAREA:
        return <FormTextarea {...item} />;
      default:
        return <></>;
    }
  }
  return (
    <div className="report-group">
      {title && (
        <h2 className="report-group-title">
          <FormTitle title={title} /> {required && <span className="report-group-required"> *</span>}
        </h2>
      )}
      {des && <div className="report-group-des">{des}</div>}
      {formList.map((item, index) => {
        return (
          <div className="report-group-item" key={index}>
            <RenderFormItem {...item} />
          </div>
        );
      })}
    </div>
  );
}

export default FormGroup;
